import CompatsWidget from './compats-widget-wrapper';

export default CompatsWidget;
